import {
    CHANGE_NAME,
    CHANGE_PHONE_NUMBER,
    CHANGE_AGE,
    CHANGE_GENDER,
    CHANGE_MARITAL_SATUS,
    CHANGE_BUDGET,
    CHANGE_UNIT_TYPE,
    CHANGE_MESSAGE,
    SUBMIT_CONTACT_SUCCESS,
    SUBMIT_CONTACT_FAILED
} from '../actions/types'

const INITIAL_STATE = {
    name: '',
    phone_number: '',
    age: '',
    gender: '',
    marital_status: '',
    budget: '',
    unit_type: '',
    message: '',
    source:'web',
    success: false,
    error: false,
}

export default (state = INITIAL_STATE, action) => {

   // console.log("action", action.type)

    switch(action.type) {
        
        case CHANGE_NAME:
            return {...state, name: action.payload}

        case CHANGE_PHONE_NUMBER:
            return {...state, phone_number: action.payload}

        case CHANGE_AGE:
            return {...state, age: action.payload}
        
        case CHANGE_GENDER:
            return {...state, gender: action.payload}
        
        case CHANGE_MARITAL_SATUS:
            return {...state, marital_status: action.payload}
        
        case CHANGE_BUDGET:
            return {...state, budget: action.payload}

        case CHANGE_UNIT_TYPE:
            return {...state, unit_type: action.payload}

        case CHANGE_MESSAGE:
            return {...state, message: action.payload}
        
        case SUBMIT_CONTACT_SUCCESS:
            return {...state, success: action.payload, error: false, name: '', phone_number: '', age: '',gender: '', marital_status: '', budget: '', unit_type: '', message: '', }
        
        case SUBMIT_CONTACT_FAILED:
            return {...state, success: false, error: true}

        default:
            return state
    }

}